export default __webpack_public_path__ + "static/media/Directivos.84e9b500.png";